import { useEffect, useState } from 'react';
import useParkplusStoreV2 from 'src/modules/parkplusStoreV2/hooks/useParkplusStoreV2';
import { ShippingDataType } from 'src/modules/parkplusStoreV2/types/cart';
import { formatExpectedDeliveryLabel } from 'src/modules/parkplusStoreV2/utils/formatExpectedDelivery';
import Icon from 'ui-v2/components/Icon/Icon';
import { Typography } from 'ui-v2/components/Typography';
import s from './ShipRocketDeliveryDate.module.scss';

type ShipRocketDeliveryDatePropTypes = {
  item: ShippingDataType;
  error?: boolean;
};

export const ShipRocketDeliveryDate = ({
  item,
  error = false,
}: ShipRocketDeliveryDatePropTypes) => {
  const { deliveryAddressData } = useParkplusStoreV2();

  const [deliveryInfo, setDeliveryInfo] = useState({
    status: 2,
    expectedDelivery: 0,
    deliveryMessage: '',
    show: false,
  });

  const checkDelivery = async () => {
    const response = item;
    if (response?.isServiceable) {
      setDeliveryInfo({
        status: 1,
        expectedDelivery: response.expectedDeliveryDays,
        deliveryMessage: response.deliveryMessage ?? '',
        show: true,
      });
    } else {
      setDeliveryInfo({
        status: 0,
        show: true,
        expectedDelivery: 0,
        deliveryMessage: '',
      });
    }
  };

  useEffect(() => {
    checkDelivery();
  }, [deliveryAddressData?.pincode, item, error]);

  const { status, expectedDelivery, deliveryMessage, show } = deliveryInfo;

  return (
    <div className={s.pincodeContainer}>
      {show && !error && status === 1 && (
        <div className={s.delivery_message}>
          <Icon name="TruckRegular" color="secondary" width={16} height={16} />
          <Typography
            label="Delivery by"
            variant="tiny_medium"
            color="secondary"
          />
          <Typography
            label={formatExpectedDeliveryLabel({
              days: expectedDelivery,
              deliveryMessage,
            })}
            variant="tiny_medium"
            color="secondary"
          />
        </div>
      )}
      {error && (
        <div className={s.delivery_message}>
          <Icon name="TruckRegular" color="secondary" width={16} />
          <Typography
            label="Delivery within"
            variant="tiny_medium"
            color="secondary"
          />
          <div>
            <Typography
              label="6-7 days"
              variant="tiny_medium"
              color="secondary"
            />
          </div>
        </div>
      )}
      {status === 0 && show && !error && (
        <div className={s.delivery_message}>
          <Typography
            label="We do not deliver to this location yet, change pincode"
            variant="tiny_medium"
            color="negative"
          />
        </div>
      )}
    </div>
  );
};
